// extracted by mini-css-extract-plugin
export default {"element":"guidelines_element__Yf2Y1","applicationEnd":"guidelines_applicationEnd__qa02z"};